import React from 'react';
import { Theme, Typography } from '@material-ui/core';
import { createStyles, makeStyles } from '@material-ui/core/styles';
import ProcoreIcon from '../icons/ProcoreIcon';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      display: 'inline-flex',
      alignItems: 'center',
      backgroundColor: theme.palette.secondary.main,
      borderRadius: 16,
      padding: theme.spacing(1, 1.5),
    },
    label: {
      marginLeft: theme.spacing(1),
      color: '#FFFFFF',
      fontWeight: 500,
      lineHeight: '16px',
      whiteSpace: 'nowrap',
      fontSize: 13,
    },
  }),
);

type ProcoreSyncPillProps = {
  className?: string;
  style?: React.CSSProperties;
};

/** Orange pill shown on pages whose project has an active Procore sync. */
export default function ProcoreSyncPill(props: ProcoreSyncPillProps) {
  const classes = useStyles();
  const { className, style } = props;

  return (
    <div className={className ? `${classes.root} ${className}` : classes.root} style={style}>
      <ProcoreIcon width={16} height={16} />
      <Typography variant="body2" className={classes.label}>
        Procore Sync Active
      </Typography>
    </div>
  );
}
